/*
 * Author: daiwei
 * File Created: Tuesday, 24-05-07 11:01 am
 * Last Modified: Monday, 25-04-28 05:35 pm, by Dw
 */

import { Logger } from '@web/utils';

export const logger = new Logger({
  module: 'ucard-core',
});
